













import { Component, Vue } from "vue-property-decorator";

@Component({
    components: {}
})

export default class AccessRestriction extends Vue {
  
  private contentHeader: string = 'Access to this page is restricted';
  private content: string = 'Please check with the App admin if you believe this is a mistake.';
  private btnMessage: string = 'GO TO THE GALLERY';

}
